import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';
import { ParamsBuilder } from '@shared/models/params-builder';

@Injectable({
  providedIn: 'root'
})
export class ExtendSerialApi extends ApiCommon {

  getExtendSerials(pageEvent, q?: any, query?: any): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;

    if (q && JSON.stringify(q) !== '{}') {
      builder.q = q;
    }

    if (query) {
      builder.query = query;
    }

    return this.apiServer.extendSerial.getExtendSerials(builder.build());
  }

  getExtendSerialBySerialNo(serialNo): Observable<any> {
    return this.apiServer.extendSerial.getExtendSerialBySerialNo(serialNo);
  }

  saveExtendSerial(extendSerialInfo): Observable<any> {
    return this.apiServer.extendSerial.saveExtendSerial(extendSerialInfo);
  }

  editExtendSerial(extendSerialInfo): Observable<any> {
    return this.apiServer.extendSerial.editExtendSerial(extendSerialInfo);
  }

  deleteExtendSerial(extendSerialDetail): Observable<any> {
    return this.apiServer.extendSerial.deleteExtendSerial(extendSerialDetail);
  }
}
